import React from 'react';
import PropTypes from 'prop-types';
import SubjectGroup from './SubjectGroup';

export default class SearchFilterSubjects extends React.PureComponent {
  state = {
    text: '',
  };

  componentDidMount() {
    if (this.props.subjects.loaded) return;
    this.props.fetchSubjects();
  }

  inputChange = (e) => {
    this.setState({ text: e.target.value });
  };

  render() {
    const {
      filter,
      subjects,
    } = this.props;

    const { groups } = subjects;

    const inputId = 'SearchFilterSubjects-input';

    return (
      <div>
        <div className="form-group">
          <label htmlFor={inputId}>Search topics you're interested</label>
          <input onChange={this.inputChange} value={this.state.text} className="form-control" id={inputId} type="text" placeholder="Leadership" />
        </div>
        {groups.list.map((id) => {
          const group = groups.byId[id];

          return (
            <SubjectGroup
              subjects={subjects}
              group={group}
              key={group.id}
              text={this.state.text}
              filter={filter}
            />
          );
        })}
      </div>
    );
  }
}

SearchFilterSubjects.propTypes = {
  fetchSubjects: PropTypes.func.isRequired,
  filter: PropTypes.shape({}).isRequired,
  subjects: PropTypes.shape({}).isRequired,
};
